import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Demande from "./pages/demande";
import AjouterDemandeLogiciel from "./pages/AjouterDemandeLogiciel";

// Importez tous vos composants de pages

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/demande" element={<Demande />} />
          <Route
            path="/AjouterDemandeLogiciel"
            element={<AjouterDemandeLogiciel />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
